import { render } from "./RenegadoPrivacyPolicy.vue?vue&type=template&id=60cf4ad0&scoped=true"
import script from "./RenegadoPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./RenegadoPrivacyPolicy.vue?vue&type=script&lang=js"

import "./RenegadoPrivacyPolicy.vue?vue&type=style&index=0&id=60cf4ad0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60cf4ad0"]])

export default __exports__